// app/licenza/licenza.js

(function () {
    'use strict';
    var controllerId = 'licenza';
    angular.module('app').controller(controllerId, ['common', 'bootstrap.dialog', '$location', '$window', '$rootScope', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', '$filter', '$translate', licenzaFn]);

    function licenzaFn(common, bDialog, $location, $window, $rootScope, $routeParams, $uibModal, datacontext, sectionMenu, $filter, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 

        var vm = this;
        vm.sectionMenu = sectionMenu.setSection('Licenza');
        vm.record = {};
        vm.acquista = acquista;
        vm.ordineDetail = ordineDetail;
        vm.getOrdini = getOrdini;
        vm.list = {};
        vm.list.ordini = [];
        vm.provincie = [];
        vm.comuni = [];
        vm.update = updateItem;
        vm.getComuni = getComuni;
        vm.setConsenso = setConsenso;

        vm.materie = [];
        vm.flag_modifica = 0;
        vm.getFlag = getFlag;

        vm.loading = false;
        vm.formInvalid = true;
        vm.codiceLicenza = "";
        vm.lingua = [{ name: $translate.instant('Italiano'), value: 'it' }, { name: $translate.instant('Inglese'), value: 'en' }];

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [$rootScope.getWhoAmI(), getMaterie()];
            common.activateController(promises, controllerId)
                    .then(function () {
                        vm.record = getRisorsa();
                    });
        }

        function getRisorsa() {
            if (vm.provincie.length == 0) getProvincie();

            return datacontext.risorsa_getByUsername().then(function (data) {
                data.DataFineLicenza = $rootScope.dataLicenza;
                getComuni(data.ProvinciaId);
                getCodiceLicenza(data.Id);
                vm.record = data;
                validaForm();
                vm.record.Lingua = $rootScope.lingua;
                return vm.record;
            });
        }

        function getOrdini() {
            return datacontext.ordine_getAllByDocente().then(function (data) {
                return vm.list.ordini = data;
            });
        }

        function getProvincie() {
            if (vm.provincie.length > 0) return;

            datacontext.arrProvincie().then(function (data) {
                vm.provincie = data;
            });
        }

        function getComuni(idprov) {
            if (!idprov || idprov == 0) return vm.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.comuni = data;
            });
        }

        function getCodiceLicenza(docenteId) {
            if (!docenteId || docenteId == 0) return "";

            return datacontext.risorsa_getCodiceLicenza(docenteId).then(function (data) {
                return vm.codiceLicenza = data;
            });
        }

        function updateItem() {
            validaForm();
            if (vm.formInvalid == false) {
                return datacontext.risorsa_update(vm.record).then(function (data) {
                    if (!data) {    //Il salvataggio è andato a buon fine
                        $translate.use(vm.record.Lingua);                        
                        vm.currentLanguage = vm.record.Lingua;
                        activate();
                        
                        if (vm.currentLanguage == 'it') {
                            vm.lingua = [{ name: 'Italiano', value: 'it' }, { name: 'Inglese', value: 'en' }];
                            logSuccess('Dati Salvati');
                        }
                        else {
                            vm.lingua = [{ name: 'Italian', value: 'it' }, { name: 'English', value: 'en' }];
                            logSuccess('Saved Data');
                        }
                    }
                    else
                        logError($translate.instant('ImpossibileSalvareDati'));
                });
            }           
        }

        function validaForm() {
            vm.formInvalid = true;
            if (vm.record.Cognome == null || vm.record.Cognome.trim().length == 0) {
                return;
            }
            if (vm.record.Nome == null || vm.record.Nome.trim().length == 0) {
                return;
            }
            if (vm.record.CodiceFiscale == null || vm.record.CodiceFiscale.trim().length == 0) {
                return;
            }
            if (vm.record.Indirizzo == null || vm.record.Indirizzo.trim().length == 0) {
                return;
            }
            if (vm.record.ProvinciaId == null || vm.record.ProvinciaId == 0) {
                return;
            }
            if (vm.record.ComuneId == null || vm.record.ComuneId == 0) {
                return;
            }
            if (vm.record.Cap == null || vm.record.Cap.trim().length == 0) {
                return;
            }
            if (vm.record.Email == null || vm.record.Email.trim().length == 0) {
                return;
            }

            vm.formInvalid = false;
        }

        function setConsenso() {
            if (vm.record.ConsensoDati)
                vm.record.DataConsenso = new Date();
            else
                vm.record.DataConsenso = null;
        }
        
        function getFlag() {
            return vm.flag_modifica = 1;
        }

        function getMaterie() {
            if ($rootScope.isAuthorized("STUDENTE")) {
                return datacontext.materia_getAllListByDocente(vm.record.docenteId).then(function (data) {
                    return vm.materie = data;
                });
            }
            else {
                return datacontext.materia_getAllList().then(function (data) {                    
                    return vm.materie = data;
                });
            }
        }

        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************
        function acquista() {
            if (vm.formInvalid)
                return;

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/licenza/modal/licenzaAdd.html?version=43',
                controller: 'licenzaAdd'
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem.strumF == "CD") { //Carta Docente                     
                    logSuccess($translate.instant('OrdineCompletato'));
                    activate();
                    getOrdini();
                    vm.loading = false;
                }
                else {
                    var msg = $translate.instant('ConfermiAcquisto');
                    bDialog.confirmationDialog($translate.instant('ConfermaAcquisto'), msg, "OK").then(function () {
                        vm.loading = true;

                        datacontext.ordine_calcola().then(function (data) {
                            if (data == null || data == '400' || data == '500') {
                                logError($translate.instant('ImpossibileProcessare'));
                                vm.loading = false;
                                return;
                            }

                            var url = $location.absUrl().toLowerCase();

                            if (returnItem.strumF == "P") {
                                var url2 = url.replace("/home/ruolo_docente#/licenza", "/licence/paypal");
                                $window.location.href = url2;
                            }
                            else if (returnItem.strumF == "B") {
                                datacontext.ordine_postBonifico(returnItem).then(function (data) {
                                    if (data == null || data == '400' || data == '500') {
                                        logError($translate.instant('ImpossibileProcessare'));
                                        vm.loading = false;
                                        return;
                                    }
                                    else {
                                        logSuccess($translate.instant('OrdineCompletato'));
                                        activate();
                                        getOrdini();
                                        vm.loading = false;
                                    }
                                });
                            }
                        });
                    });
                }
            });
        }

        function ordineDetail(item) {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/licenza/modal/ordineDetail.html?version=43',
                controller: 'ordineDetail',
                resolve: {
                    ordine: function () {
                        return item;
                    }
                }
            });
        }       
    }
})();
